/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Videos_QuotaInputs */

const cs_videos_quota = /** @type {(inputs: Videos_QuotaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Až ${i?.max} videí na inzerát`)
};

const en_videos_quota = /** @type {(inputs: Videos_QuotaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Up to ${i?.max} videos per listing`)
};

/**
* | output |
* | --- |
* | "Up to {max} videos per listing" |
*
* @param {Videos_QuotaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const videos_quota = /** @type {((inputs: Videos_QuotaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Videos_QuotaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_videos_quota(inputs)
	return cs_videos_quota(inputs)
});